import { Edit } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { Button, Divider, Stack, Typography } from "~/common/mui";
import { CART_PAGE } from "~/utils/url/staticUrls";

export const CartSectionTitle = ({
  title,
  subtitle,
  editCart,
}: {
  title: string;
  subtitle?: string;
  editCart?: boolean;
}) => {
  const { t } = useTranslation();
  return (
    <Stack gap={1}>
      <Stack direction="row" justifyContent={"space-between"}>
        <Stack gap={1}>
          <Typography variant="headlineSmall">{title}</Typography>
          {subtitle && <Typography>{subtitle}</Typography>}
        </Stack>
        {editCart && (
          <Button variant="text" href={CART_PAGE} startIcon={<Edit />}>
            {t("checkoutPage.editCart")}
          </Button>
        )}
      </Stack>
      <Divider />
    </Stack>
  );
};
